import React from 'react';
import PartsTable from "../components/PartsTable";
import px from "../data/px";

function PartsPage() {
    
    return (
        <>
        <article className="App-weather">
        
        <PartsTable partsx={px}/> 
        </article>

    </>
    );
}
export default PartsPage;
